import { UseSheetTheme } from '../../../hooks/useSheetTheme';
import { Size } from '../../../../core/types/ui/size';
import { IPosition2d } from '../../../../core/types/ui/position';
import { Group, Rect, Text } from 'react-konva';
import { UseCellSelection } from '../../../hooks/useCellSelection';
import { SelectionCell, SelectionOperationType } from '../../../types';
import { useMemo } from 'react';
import { SheetDefaults } from '../../../constants/sheetDefaults';

interface RowHeaderCellProps
  extends Size,
    IPosition2d,
    Pick<UseCellSelection, 'onCellMouseDown' | 'onActiveHeaderMouseDown'>,
    Pick<UseSheetTheme, 'stroke' | 'fill' | 'textColor'> {
  // positionIndex: number;
  rowIndex: number;
  isSelected: boolean;
  underSelection: boolean;
  isActiveSelection: boolean;
  zoom: number;
}

const RowHeaderCell: React.FC<RowHeaderCellProps> = ({
  x,
  y,
  width,
  height,
  // positionIndex,
  rowIndex,
  fill,
  textColor,
  stroke,
  underSelection,
  isSelected,
  isActiveSelection,
  zoom,
  onCellMouseDown,
  onActiveHeaderMouseDown,
}) => {
  const background = () => (
    <Rect
      height={height}
      width={width}
      fill={fill}
      stroke={stroke}
      strokeWidth={1 * zoom}
      listening
      hitStrokeWidth={0}
      // opacity={0.2}
    />
  );

  const text = () => (
    <Text
      height={height}
      width={width}
      align="center"
      verticalAlign="middle"
      // fontSize={12}
      fontSize={Math.floor(SheetDefaults.rowHeaderWidth / 3.5) * zoom}
      text={`${rowIndex + 1}`}
      fill={textColor}
      fontStyle={underSelection ? 'bold' : 'normal'}
    />
  );

  return useMemo(
    () => (
      <Group
        x={x}
        y={y}
        onMouseDown={
          (e) =>
            isActiveSelection
              ? onActiveHeaderMouseDown(
                  e,
                  SelectionOperationType.RowMove,
                  rowIndex
                )
              : onCellMouseDown(e, SelectionCell.Row, { ci: 0, ri: rowIndex }) // positionIndex
        }
        onContextMenu={(e) =>
          onCellMouseDown(e, SelectionCell.Row, { ci: 0, ri: rowIndex })
        }
      >
        {background()}
        {text()}
      </Group>
    ),
    [
      x,
      y,
      width,
      height,
      rowIndex,
      fill,
      textColor,
      stroke,
      underSelection,
      isSelected,
      isActiveSelection,
      onCellMouseDown,
    ]
  );

  //   return (
  //     <Box
  //       left={`${x}px`}
  //       top={`${y}px`}
  //       width={`${width}px`}
  //       height={`${height}px`}
  //       borderTop={`1px solid ${stroke}`}
  //       borderRight={`1px solid ${stroke}`}
  //       borderBottom={`1px solid ${stroke}`}
  //       background={isFilteredRow ? filterAppliedFill : fill}
  //       position="absolute"
  //       display="flex"
  //       alignItems="center"
  //       justifyContent="center"
  //       overflow="hidden"
  //       fontSize="12px"
  //       fontFamily="arial"
  //     >
  //       {index + 1}
  //     </Box>
  //   );
};

export default RowHeaderCell;
